import Hightlighter from 'react-highlight-words';
import * as S from './ChooseCampaigns.styled';
import { Checkbox } from 'components';

export const Content = ({ foundedCampaigns, search, isActive, toggle }) => {
  return (
    <S.ItemsGroup>
      {foundedCampaigns?.map(({ cm_name, cm_campaignid }) => (
        <S.Group key={cm_campaignid}>
          <S.Row>
            <Checkbox
              id={`${cm_campaignid}`}
              isChecked={isActive(cm_campaignid)}
              name={cm_campaignid}
              onChange={toggle}
            />
            <S.GroupName onClick={() => toggle(true, cm_campaignid)}>
              <Hightlighter
                textToHighlight={cm_name}
                searchWords={[search]}
                highlightTag='strong'
              />
            </S.GroupName>
          </S.Row>
        </S.Group>
      ))}
    </S.ItemsGroup>
  );
};
